import { useLocation } from "react-router-dom";
import Api from "../core/api";
import { API_ACTIVITY } from '../core/constants';
import { Auth } from "../services"

export interface UserActivity {
  action?: string;
  client?: string;
  username?: string;
  requestTime?: string;
  url?: string;
  page?: string;
  pageId?: string;
  viewName?: string;
  viewId?: string;
  subViewName?: string;
  subViewId?: string;
  entityId?: string;
  entityName?: string;
  metadata?: string;
}

export const logUserActivity = (userActivity: UserActivity) => {
  userActivity.client = 'WK';
  userActivity.username = Auth.getUserame() || '';
  userActivity.url = window.location.href;
  userActivity.requestTime = new Date().toISOString();

  Api.postRequest(`${API_ACTIVITY.ADD_ACTIVITY}`, userActivity).then(
    (res: any) => {
      console.log('track success');
    },
    (err: any) => {
      console.error('track ERROR');
    }
  )
}